<div class="k-overlay wk-cat__overlay wk-cat__overlay--zindex"></div>
<kendo-window
    [width]="dialogWidth"
    [height]="dialogHeight"
    [minWidth]="dialogMinWidth"
    [minHeight]="dialogMinHeight"
    (keydown.escape)="onClose($event)"
    [resizable]="false"
    @dialogSlideInAppear
>
    <!-- Could not use ripple within this tag, leave empty to prevent default titlebar -->
    <kendo-window-titlebar />
    <ng-template #template let-anchor>
        <span>{{ anchor.nativeElement.innerText }}</span>
    </ng-template>
    <div kendoTooltip showOn="none" [tooltipTemplate]="template" (mouseover)="showTooltip($event)">
        <div class="wk-cat__header">
            <div class="wk-cat__header-title">{{ "CardModal.AuditTrail" | translate }}</div>
            <div class="wk-cat__header__actions">
                <div
                    class="fa wk-cat__header__actions-button wk-cat__header__actions-toggle-size"
                    [class.fa-expand]="!isMaximized"
                    [class.fa-compress]="isMaximized"
                    (click)="toggleSize()"
                ></div>
                <div class="fa fa-close wk-cat__header__actions-button wk-cat__header__actions-close" (click)="onClose(null)"></div>
            </div>
        </div>
        <div class="wk-cat__container">
            <div class="wk-cat__filters">
                <div class="wk-cat__filter wk-cat__filter-made-on">
                    <div class="wk-cat__filter-title">{{ "AuditTrail.MadeOn" | translate }}</div>
                    <div class="wk-cat__filter__inputs">
                        <div class="wk-cat__filter__input">
                            <label class="wk-cat__filter__input-label">{{ "AuditTrail.From" | translate }}</label>
                            <kendo-datepicker
                                format="yyyy-MM-dd"
                                placeholder="YYYY-MM-DD"
                                (keydown)="onKeyDown($event)"
                                (valueChange)="FromDatehandler($event)"
                            >
                                <kendo-datepicker-messages
                                    today="{{ 'Code.Today' | translate }}"
                                    toggle="{{ 'CardModal.ToggleCalendar' | translate }}"
                                ></kendo-datepicker-messages>
                            </kendo-datepicker>
                        </div>
                        <div class="wk-cat__filter__input">
                            <label class="wk-cat__filter__input-label">{{ "AuditTrail.To" | translate }}</label>
                            <kendo-datepicker
                                format="yyyy-MM-dd"
                                placeholder="YYYY-MM-DD"
                                (keydown)="onKeyDown($event)"
                                (valueChange)="ToDatehandler($event)"
                            >
                                <kendo-datepicker-messages
                                    today="{{ 'Code.Today' | translate }}"
                                    toggle="{{ 'CardModal.ToggleCalendar' | translate }}"
                                ></kendo-datepicker-messages>
                            </kendo-datepicker>
                        </div>
                    </div>
                </div>
                <div class="wk-cat__filter">
                    <div class="wk-cat__filter-title">{{ "AuditTrail.Users" | translate }}</div>
                    <div class="wk-cat__filter__input">
                        <kendo-multiselect-wrapper
                            name="userIDSelect"
                            [data]="userIDData.Option"
                            textField="value"
                            valueField="value"
                            placeholder="{{ 'AuditTrail.AllPlaceholder' | translate }}"
                            [(ngModel)]="userIDData.selectedValues"
                            (ngModelChange)="UserValueChange()"
                            [virtual]="true"
                        />
                    </div>
                </div>
                <div class="wk-cat__filter">
                    <div class="wk-cat__filter-title">{{ "AuditTrail.Action" | translate }}</div>
                    <div class="wk-cat__filter__input">
                        <kendo-multiselect-wrapper
                            name="actionSelect"
                            [data]="actionData.Option"
                            textField="value"
                            valueField="value"
                            placeholder="{{ 'AuditTrail.ActionPlaceholder' | translate }}"
                            [(ngModel)]="actionData.selectedValues"
                            (ngModelChange)="ActionValueChange()"
                        />
                    </div>
                </div>
            </div>
            <kendo-textbox placeholder="{{ 'SearchBar.PlaceHolder' | translate }}" (keydown)="onKeyDown($event)" (valueChange)="onChange($event)">
                <button kendoButton fillMode="flat"></button>
            </kendo-textbox>
            <kendo-grid
                class="wk-cat__table"
                [data]="gridView"
                [loading]="isLoading"
                [pageSize]="pageSize"
                [skip]="skip"
                [pageable]="{
                    buttonCount: pagerButtonCount,
                    info: pagerInfo,
                    type: type,
                    pageSizes: pageSizes,
                    previousNext: previousNext,
                    position: position,
                }"
                (pageChange)="pageChange($event)"
            >
                <kendo-grid-column field="user" title="{{ 'AuditTrail.User' | translate }}" headerClass="wk-cat__table__header-user" />
                <kendo-grid-column field="action" title="{{ 'AuditTrail.Action' | translate }}" headerClass="wk-cat__table__header-action" />
                <kendo-grid-column field="entity" title="{{ 'AuditTrail.Value' | translate }}" headerClass="wk-cat__table__header-entity" />
                <kendo-grid-column field="timestamp" title="{{ 'AuditTrail.MadeOn' | translate }}" headerClass="wk-cat__table__header-timestamp" />
                <ng-template kendoGridLoadingTemplate>
                    <div class="wk-cat__table-loading">
                        <i class="loader fa fa-spinner fa-pulse"></i>
                    </div>
                </ng-template>
                <ng-template kendoGridNoRecordsTemplate>
                    @if (!isLoading) {
                        <div>{{ "AuditTrail.NoRecords" | translate }}</div>
                    }
                </ng-template>
            </kendo-grid>
            <div class="wk-cat__actions">
                <button type="button" class="btn-secondary wk-cat__actions-button" (click)="onClose(null)">
                    <span aria-hidden="true">{{ "General.Close" | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</kendo-window>
